import colors from "../theme/colors";

const DEFAULT_KEY = "rzp_live_TK3DGNsXEuWjpz";

export const getRazorpayKey = () =>
  process.env.REACT_APP_RAZORPAY_KEY || DEFAULT_KEY;

export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

/**
 * Opens Razorpay Checkout for amountInr (shortfall only).
 * onSuccess receives razorpay_payment_id.
 */
export const openRazorpayCheckout = async ({
  amountInr,
  description,
  onSuccess,
  onDismiss,
}) => {
  const loaded = await loadRazorpayScript();
  if (!loaded) {
    throw new Error("Razorpay SDK failed to load. Please check your connection.");
  }
  const amount = Math.round(Number(amountInr) * 100);
  if (!Number.isFinite(amount) || amount <= 0) {
    throw new Error("Invalid payment amount.");
  }

  return new Promise((resolve, reject) => {
    const options = {
      key: getRazorpayKey(),
      amount,
      currency: "INR",
      name: "Elthium Health",
      description: description || "Booking payment",
      handler(response) {
        const paymentId = response.razorpay_payment_id;
        Promise.resolve(onSuccess(paymentId)).then(resolve).catch(reject);
      },
      modal: {
        ondismiss() {
          onDismiss?.();
          reject(new Error("Payment cancelled"));
        },
      },
      prefill: {
        name: localStorage.getItem("staffName") || "Customer",
        email: localStorage.getItem("staffEmail") || "customer@example.com",
        contact: localStorage.getItem("staffPhone") || "9999999999",
      },
      theme: { color: colors.primary },
    };
    const instance = new window.Razorpay(options);
    instance.on("payment.failed", () => {
      reject(new Error("Payment failed. Please try again."));
    });
    instance.open();
  });
};
